export const SITE_CONFIG = {
  name: 'InfoForge',
  title: 'InfoForge · Plataforma de Engenharia de Infoprodutos Assistida por IA',
  description: 'Centralize pesquisa de mercado, arquitetura de conteúdo, compilação de ebooks (PDF/EPUB), workbooks e campanhas com consistência integral.',
  domain: 'https://infoforge.com.br',
  apiUrl: 'https://infoforge-api.db8intelligence.com.br',
  saasAppUrl: 'https://infoforge.db8intelligence.com.br',
  loginUrl: 'https://infoforge.db8intelligence.com.br/login',
  contactEmail: 'contato@infoforge.com.br',
  supportEmail: 'suporte@db8intelligence.com.br',
  company: 'DB8 Intelligence',
  year: 2026,
  statusBadge: 'PRIVATE BETA FECHADO · LOTE 1',
  signupStatus: 'CLOSED', // Public signup remains closed
};

// Analytics Event Logger (No PII)
export function trackEvent(
  eventName:
    | 'hero_cta'
    | 'waitlist_open'
    | 'waitlist_submit'
    | 'waitlist_success'
    | 'waitlist_error'
    | 'login_click'
    | 'plans_cta'
    | 'final_cta',
  metadata?: Record<string, string | number | boolean>
) {
  try {
    const payload = {
      event: eventName,
      timestamp: new Date().toISOString(),
      path: window.location.pathname,
      ...metadata,
    };
    // Dispatch custom DOM event for external listeners / GTM / Plausible
    window.dispatchEvent(new CustomEvent('infoforge:track', { detail: payload }));
    if (process.env.NODE_ENV === 'development') {
      console.log('[Analytics Event]', eventName, payload);
    }
  } catch {
    // Non-blocking telemetry
  }
}
